<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :label="$lang.block" v-model="block" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" :label="$lang.disabled" v-model="disabled" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dense" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dense" /><!--
          --><checkbox label-size="xs" :label="$lang.dismissible" v-model="dismissible" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="6" md12 sm12 xs24 v-if="chips.length" v-for="(chip, index) in chips" :key="index">
        <chip
          @dismiss="log('dismissed', 'chip', chip)"
          color="white"
          v-model="chip.model"
          :dense="dense"
          :block="block"
          :bg-color="chip.bgColor"
          :bg-color-lightness="500"
          :avatar-src="chip.avatar.replace('/static', `${$root.config.staticAssetsDir}`)"
          :dismissible="dismissible"
          :color-lightness="null"
          :disabled="disabled">{{ chip.label }}</chip>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageChip',
  mixins: [
    methods
  ],
  data () {
    return {
      chips: [],
      dense: false,
      dismissible: true,
      disabled: false,
      block: false
    }
  },
  mounted () {
    this.getExternalData('chip.json', 'chips')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/chip.vue